


/* --------------------------- FAQの開閉 --------------------------- */

$('.ru_faq_q').on('click', function (e){
  e.preventDefault();
  $(this).toggleClass("active");
  $(this).next().slideToggle();
});


/* ------------------------------ 2023 夏季休暇のお知らせ------------------------------ */
/*

※カスタマイズの実装にしたのでこちらはもう使わない

//テキスト内容
var noticeContentHtml = `
8月︎10日（木）～8月︎17日（木）、夏季のお休みをいただきます。<br>
<br>
上記期間中のご注文につきましては、8月18日（金）より順次発送いたします。<br>
なお、お電話およびメールでのお問い合わせも、8月︎18日（金）より順次対応となりますので、ご理解のほどよろしくお願いいたします。<br>
<br>
カラフルな夏をお楽しみください。<br>
<br>
Make your summer colorful w/ REUNION
`;
var summer2023Key = 'summer2023Key'
var summer2023Val = $.cookie(summer2023Key);
console.log("summer2023Val", summer2023Val);
if(summer2023Val != 'done'){
  $("#NoticePopupTitle").html('夏季休業中の製品発送について');
  $("#NoticePopupText").html(noticeContentHtml);
  $("#NoticePopupClose").data('cookie-key', summer2023Key);
  showNoticePopup();
}
//最初から表示せず、少しスクロールしたら表示する
function showNoticePopup(){
  var isShow = true;
  var showScroll = window.innerHeight / 2;
  $(window).scroll(function() {
    var scroll = $(this).scrollTop();
    if(scroll > showScroll && isShow){
      $("#NoticePopup").fadeIn(300);
      isShow = false;
    }
  });
}
//Close
$("#NoticePopupClose").on('click', function(e) {
  var thisCookieKey = $(this).data('cookie-key');
  $.cookie(thisCookieKey, 'done', {
    expires: 1,
    path:'/'
  });
  $("#NoticePopup").fadeOut(300);
});
*/

/* ----------------------------------- doSomethingAfterSplash ----------------------------------- */

function doSomethingAfterSplash(){
  console.log("doSomethingAfterSplash");
  //Awardのslickが崩れるのでSplash後に再配置
  setTimeout(function(){
    $('#ruAwardTexts').slick('setPosition');
  }, 500);
}

/* ----------------------------------- Media Slider (Top, Product) ----------------------------------- */

var mediaSlider = "#ruPdtMediaTexts";
var mediaThumbs = "#ruPdtMediaLogos li";
var mediaPrev = "#ruPdtMediaLogosPrev";
var mediaNext = "#ruPdtMediaLogosNext";
initMediaSlider(mediaSlider, mediaThumbs, mediaPrev, mediaNext);

var awardSlider = "#ruAwardTexts";
var awardThumbs = "#ruAwardLogos li";
initMediaSlider(awardSlider, awardThumbs, null, null);

function initMediaSlider(slider, thumbList, prev, next){
  console.log("initMediaSlider");
  // サムネイル画像アイテムに data-index でindex番号を付与
  $(thumbList).each(function(){
    var index = $(thumbList).index(this);
    $(this).attr("data-index",index);
  });
  // スライダー初期化後、カレントのサムネイル画像にクラス「thumbnail-current」を付ける ※初期化前に記述
  $(slider).on('init',function(slick){
    $(thumbList+'[data-index="0"]').addClass("current");
  });
  //slickスライダー初期化  
  $(slider).slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 800,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '0',
    variableWidth: false
  });
  //サムネイル画像アイテムをクリックしたときにスライダー切り替え
  $(thumbList).on('click',function(){
    var index = $(this).attr("data-index");
    $(slider).slick("slickGoTo",index,false);
  });
  //サムネイル画像のカレントを切り替え
  $(slider).on('beforeChange',function(event,slick, currentSlide, nextSlide){
    $(thumbList).each(function(){
      $(this).removeClass("current");
    });
    $(thumbList+'[data-index="'+nextSlide+'"]').addClass("current");
  });
  //prev, next
  if(prev){
    $(prev).on('click',function(e){
      e.preventDefault();
      $(slider).slick('slickPrev');
    });
  }
  if(next){
    $(next).on('click',function(e){
      e.preventDefault();
      $(slider).slick('slickNext');
    });
  }
}



